"use strict";

require("element-ui/lib/theme-chalk/select.css");
require("element-ui/lib/theme-chalk/option.css");
require("element-ui/lib/theme-chalk/popover.css");
require("element-ui/lib/theme-chalk/checkbox.css");
require("element-ui/lib/theme-chalk/radio.css");
require("element-ui/lib/theme-chalk/tooltip.css");
require("./index.scss");
require("@patsnap-biz/icon/lib/style");
require("@patsnap-ui/icon/assets/solid/AddLarge.svg");
require("@patsnap-ui/icon/assets/solid/delete.svg");
require("@patsnap-ui/icon/assets/solid/info.svg");
require("@patsnap-ui/icon/assets/solid/ArrowRight.svg");
require("@patsnap-ui/icon/assets/solid/SearchLeft.svg");